import $ from 'jquery';
//import * as CONST from '../utils/constants';
//import Util from '../utils/ui';

class NewUserRegistration {
	constructor() {
		this.selectChannel = $('#select-channel');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.selectChannel.on('change', function () {
			const selectJobTitle = $('#select-jobTitle');
			selectJobTitle.val('');

			if ($(this).val() === 'Correspondent') {
				$('.branch-label').text('Branch / Joint Venture');
				selectJobTitle.addClass('correspondent-selected').removeClass('wholesale-selected');
			}
			else if ($(this).val() === 'Wholesale') {
				$('.branch-label').text('Branch');
				selectJobTitle.addClass('wholesale-selected').removeClass('correspondent-selected');
			}

			else {
				$('.branch-label').text('Branch / Joint Venture');
				selectJobTitle.removeClass('wholesale-selected, correspondent-selected');
			}
		});
	}
}

export default NewUserRegistration;